import React from 'react';
import { Layout } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { logout } from '../store/slices/authSlice';
import { authService } from '../services/authService';
import '../styles/sidebar.css';

const { Content } = Layout;

const MainLayout = ({ children, pageTitle }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { profile } = useSelector((state) => state.user);

  const handleLogout = async () => {
    try {
      const success = await authService.signOut();
      if (success) {
        dispatch(logout());
        navigate('/login');
      }
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar user={user} onLogout={handleLogout} profile={profile} />
      <Layout>
        <Header pageTitle={pageTitle} />
        <Content style={{
          padding: '24px',
          background: '#fff',
          minHeight: 'calc(100vh - 112px)',
          maxHeight: 'calc(100vh - 112px)',
          overflowY: 'scroll'
        }}>
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
